export default {"src":"/_next/static/media/comments.e8a40528.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};